/* eslint-disable complexity */
import React from 'react';
import Select from 'react-select';
import { ATCONSTANTS as ATC } from 'appconstants';
import DatePicker from 'components/Fields/DatePicker';
import DateTimePicker from 'components/Fields/DateTimePicker';
import PersonTypeAhead from 'components/Fields/typeAheads/PersonTypeAhead';
import ProtocolAndStatusTypeAhead from 'components/Fields/typeAheads/ProtocolAndStatusTypeAhead';
import SignatoryTypeAhead from 'components/Fields/typeAheads/SignatoryTypeAhead';
import InstitutionTypeAhead from 'components/Fields/typeAheads/InstitutionTypeAhead';
import PacketIdTypeAhead from 'components/Fields/typeAheads/PacketIdTypeAhead';

export function Label(props) {
  const {
    label, renderLabel, required, display, colLabel, isReplicate, icon
  } = props;
  const colVal = colLabel || '';
  const displayVal = display || '';
  const ariaTextLabel = isReplicate
    ? label && typeof label === 'string' && label.split(' ').join('R')
    : label && typeof label === 'string' && label.split(' ').join('');
  return (
    <label
      htmlFor={label}
      id={ariaTextLabel}
      style={{ display: displayVal }}
      className={`${colVal} justify-content-end`}
      data-testid={label}
      aria-label={label}
    // className={colVal}
    >
      {icon || ''}
      {required && (label || renderLabel) ? <span className="form-layout-required">*</span> : null}
      {renderLabel != null ? renderLabel() : label}
    </label>
  );
}

export function FormRadio({
  labelId, selectedVal, onChange, options, required, label, error, colLabel, colSize
}) {
  const labelSize = colLabel || 'col-4';
  const columnSize = colSize || 'col-8';
  return (
    <div role="group" aria-labelledby={labelId} className="form-group row">
      <div id={labelId} className={`form-group-label ${labelSize}`}>
        {required && <span className="form-layout-required">*</span>}
        {' '}
        {label}
      </div>
      <div className={`form-layout-input ${columnSize}`}>
        <div className="form-group-options">
          <div className="form-layout-inline">
            {options.map(({
              rLabel, value, name, id
            }) => (
              <li key={id} style={{ display: 'contents' }}>
                <input
                  id={id}
                  type="radio"
                  data-id={`${ATC.APP}${value.toUpperCase()}${ATC.INPUT}`}
                  name={name}
                  value={value}
                  checked={selectedVal === value}
                  onChange={onChange}
                  data-testid={name}
                />
                <label htmlFor={id}>{rLabel}</label>
              </li>
            ))}
          </div>
        </div>
        {error && <div className="form-layout-message-error">{error}</div>}
      </div>
    </div>
  );
}

function SelectField({
  name, value, onChange, options, required, dataId
}) {
  const val = value != null ? options.find((o) => o.value === value) : null;
  return (
    <Select
      name={name}
      required={required}
      options={options}
      data-id={dataId || `${ATC.IRBID}${name.split(' ').join('_').toUpperCase()}${ATC.SELECT}`}
      onChange={onChange}
      value={val}
      isClearable={false}
      className="reactSelect-wrapper"
      classNamePrefix="reactSelect"
      menuPosition="fixed"
    />
  );
}

function TextArea({
  name, value, onChange, required, dataId, rows, cols
}) {
  return (
    <textarea
      data-id={dataId}
      value={value}
      name={name}
      required={required}
      onChange={onChange}
      rows={rows}
      cols={cols}
    />
  );
}

const CheckboxGroup = props => {
  const {
    selectedVal, onChange, options, disabled
  } = props;
  return options.map(({
    id, name, rLabel, value
  }) => (
    <li key={id} style={{ display: 'contents' }}>
      <input
        id={id}
        type="checkbox"
        data-id={`${ATC.APP}${value.toUpperCase()}${ATC.INPUT}`}
        name={name}
        value={value}
        checked={selectedVal === value}
        onChange={onChange}
        readOnly={disabled}
      />
      <label htmlFor={id}>{rLabel}</label>
    </li>
  ));
};
function TypeAhead({
  name, label, ...rest
}) {
  const ariaTextLabel = label && typeof label === 'string' && label.split(' ').join('R');
  switch (name) {
    case 'person':
      return <PersonTypeAhead {...rest} ariaText={ariaTextLabel} />;
    case 'protocol':
      return <ProtocolAndStatusTypeAhead {...rest} />;
    case 'institution':
      return <InstitutionTypeAhead ariaText={ariaTextLabel} {...rest} />;
    case 'signatory':
      return <SignatoryTypeAhead {...rest} />;
    case 'packet':
      return <PacketIdTypeAhead {...rest} />;
    default:
      return null;
  }
}

export const getEditableField = (props) => {
  const {
    type, error, label, isReplicate, portal = false, ...rest
  } = props;

  switch (type) {
    case 'typeahead':
      return <TypeAhead label={label} isReplicate={isReplicate} {...rest} />;
    case 'date':
      return <DatePicker portal={portal} {...rest} />;
    case 'datetime':
      return <DateTimePicker {...rest} />;
    case 'select':
      return <SelectField {...rest} />;
    case 'textarea':
      return <TextArea {...rest} />;
    case 'checkboxGroup':
      return <CheckboxGroup {...rest} />;
    default:
      return (
        <input data-id={rest.dataId} required={rest.required} className={`${error ? 'is-invalid' : ''}`} {...rest} />
      );
  }
};

function ReadyOnlyIRBRow(props) {
  const {
    editMode, value, infoButton, replicateButton
  } = props;
  return value != null && (typeof value === 'string' || typeof value === 'number') ? (
    <>
      {value}
      {infoButton != null ? infoButton : null}
      {!editMode && replicateButton != null ? replicateButton : null}
    </>
  ) : null;
}

const EditableIRBRow = (props) => getEditableField(props);

function FormRowIRB(props) {
  const {
    readOnly, label, required, renderLabel, children, ...rest
  } = props;
  const {
    editMode, footer, labelAlign, error
  } = props;
  const colWidth = children != null ? 'col-4' : ''; // 3 : 6
  // const colWidth = '';
  return (
    <li>
      <Label
        labelAlign={labelAlign}
        label={label}
        renderLabel={renderLabel}
        required={editMode && required}
        // colLabel={children != null ? "col-6" : colWidth}
        colLabel={colWidth}
      />
      <div className={`form-layout-input ${colWidth}`}>
        {editMode && !readOnly ? <EditableIRBRow portal={true} {...rest} /> : <ReadyOnlyIRBRow {...rest} />}
        {footer != null ? footer : null}
        {error != null ? <div className="form-layout-message-error">{error}</div> : null}
      </div>
      {children != null ? <div className="col-4">{children}</div> : null}
    </li>
  );
}

function FormRow(props) {
  const {
    readOnly, children, infoButton, ...otherProps
  } = props;
  const {
    value, label, renderLabel, error, required, colSize, subColSize, colLabel, labelAlign, isReplicate
  } = props;
  //  row pl-2
  const subColCheck = () => `row ${subColSize || 'col-4'}`;
  return (
    <li>
      <Label
        labelAlign={labelAlign}
        isReplicate={isReplicate}
        label={label}
        renderLabel={renderLabel}
        required={required}
        colLabel={colLabel}
      />
      <div className={`form-layout-input ${colSize || ''}`}>
        {readOnly ? value : getEditableField({ ...otherProps, label, isReplicate })}
        {readOnly && value != null && infoButton != null ? infoButton : null}
        {error != null ? <div className="form-layout-message-error">{error}</div> : null}
      </div>
      {(children != null || (!readOnly && value != null && infoButton != null)) && (
        <div className={`${subColCheck()} ${subColCheck() && 'align-items-center'}`}>
          {!readOnly && value != null && infoButton != null ? <div className="col-1">{infoButton}</div> : null}
          {children != null ? (
            <>
              <div className="col-8">{children}</div>
              <div className="col-3" />
            </>
          ) : null}
        </div>
      )}
    </li>
  );
}

function FormRowAddPI(props) {
  const { readOnly, infoButton, ...otherProps } = props;
  const {
    value, label, renderLabel, error, required, colLabel, labelAlign
  } = props;
  return (
    <li>
      <Label labelAlign={labelAlign} label={label} renderLabel={renderLabel} required={required} colLabel={colLabel} />
      <div className="form-layout-input">
        {readOnly ? value : getEditableField(otherProps)}
        {readOnly && value != null && infoButton != null ? infoButton : null}
        {error != null ? <div className="form-layout-message-error">{error}</div> : null}
      </div>
    </li>
  );
}

export { FormRow, FormRowIRB, FormRowAddPI };
